import DocumentoService from '@/components/documentos/documento.service';
import VisualizadorPdfComponent from '@/components/visualizador-pdf/visualizador-pdf.vue';
import { EstadoDocumentoFormalizacion } from '@/shared/model/enumerations/estado-documentos-formalizacion.model';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import { EstadoSolucion } from '@/shared/model/enumerations/estado-solucion.model';
import { TipoDocumentosFormalizacion } from '@/shared/model/enumerations/tipo-documentos-formalizacion';
import { TipoSolucion } from '@/shared/model/enumerations/tipo-solucion.model';
import { Filtro } from '@/shared/model/filtro.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import Component, { mixins } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import SolicitudMixin from '@/entities/evaluacion/mixins/solicitud-mixin';
import GenerarPdfMixin from '@/entities/evaluacion/mixins/generar-pdf-mixin';
import { BvModalEvent } from 'bootstrap-vue';
import RevisionMixin from '@/entities/evaluacion/mixins/revision-mixin';
import FiltrosComponent from '@/components/filtros/filtros.vue';

@Component({
  components: {
    'visualizador-pdf': VisualizadorPdfComponent,
    filtros: FiltrosComponent,
  },
  computed: {
    numeroCvu: {
      get() {
        return this.$store.getters.userInfo?.cvu;
      },
    },
  },
})
export default class FirmaIndividualFormalizacionBecasComponent extends mixins(GenerarPdfMixin, SolicitudMixin, RevisionMixin) {
  @Inject('documentoService') private readonly documentoService: () => DocumentoService;

  public solicitudDocumentos: Solicitud;

  public documentos = null;

  public anioSolucion: number = null;

  public anios: number[];
  public currentStep = 0;
  public currentPage = 1;
  public perPage = 150;
  public readonly numeroCvu!: string;
  public cvu = null;
  public idSolicitud = '';
  public estadoSolicitud: EstadoSolicitud;
  public muestraTipoSolucion = true;
  public muestraFirmables = false;

  mounted(): void {
    this.solucionesFormalizacion();
    this.cvu = this.$store.getters.account?.id;
    this.tipoDocumento = TipoDocumentosFormalizacion.CONVENIO_EXTRANJERAS;
  }

  public regresar() {
    this.$router.go(-1);
  }

  /**
   * Filtra soluciones por tipo y estado de la solución.
   */
  private getSolucionesEvaluacion(): void {
    this.show = true;
    const filtro: Filtro = {
      solucionId: this.solucion.id,
    };
    filtro.estadoSolucion = EstadoSolucion.PUBLICADA;
    filtro.estadosSolicitud = [EstadoSolicitud.PREFORMALIZADA, EstadoSolicitud.APROBADA, EstadoSolicitud.FORMALIZADA];
    filtro.cvuSolicitante = this.numeroCvu;
    if (this.solucion.tipo != TipoSolucion.APOYOS_COMPLEMENTARIOS_EXT) {
      filtro.tiposSolucion = [TipoSolucion.BECAS_EXTRANJERAS];
    }
    const paginationQuery = {
      page: this.currentPage - 1,
      size: this.perPage,
      sort: this.sort(),
      filter: filtro,
    };

    this.revisionService()
      .getRevisionAllSolicitudAll(paginationQuery)
      .then(
        res => {
          if (res.data && res.data.length > 0) {
            for (const solicitud of res.data) {
              this.solicitudDocumentos = Solicitud.fromObject(solicitud.solicitud);
              this.idSolicitud = this.solicitudDocumentos.id;
              this.estadoSolicitud = this.solicitudDocumentos.estado;
            }
            this.consultarDocumentos();
            this.muestraFirmables = true;
            this.show = false;
          } else {
            this.show = false;
            this.muestraFirmables = false;
          }
        },
        err => {
          this.alertService().showHttpError(this, err.response);
          this.show = false;
        }
      );
  }

  /**
   * Soluciones de tipo de Beca y estado de la solución.
   */
  public solucionesFormalizacion(): void {
    this.solucions = [];
    const filtro = new Filtro();
    filtro.estadoSolucion = EstadoSolucion.PUBLICADA;
    filtro.tiposSolucion = [TipoSolucion.BECAS_EXTRANJERAS, TipoSolucion.APOYOS_COMPLEMENTARIOS_EXT];

    this.buscarSoluciones(filtro);
  }

  /**
   * Busca soluciones según el filtro proporcionado.
   */
  public async buscarSolucionesFormalizacion(filtro: Filtro) {
    this.solucions = [];
    await this.buscarSoluciones(filtro);

    this.solucions = this.solucions.filter(solucion => solucion.params?.formalizacion === true);
  }

  /**
   *Pasa a la siguente página para el buscador.
   *
   * @memberof BandejaFormalizacionComponent
   */
  public buscaSolicitudes(): void {
    this.getSolucionesEvaluacion();
  }

  /**
   * Determina si el texto o sección debe mostrarse para la vista previa o firmar el pdf
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  get mostrarTextoGenerarPdf(): boolean {
    return this.mostrarTextoGenerarPdfEvaluacion();
  }

  /**
   * Determina si debe mostrarse la sección del convenio.
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  get mostrarSeccionConvenio(): boolean {
    return this.mostrarBotonUrlDocumentoConvenio;
  }

  /**
   * Determina si el texto debe mostrarse para formalización.
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  private mostrarTextoGenerarPdfEvaluacion(): boolean {
    const anexoFirmado = this.documentos?.some(
      documento =>
        documento.tipoDocumento === TipoDocumentosFormalizacion.ANEXO_EXTRANJERAS &&
        documento.estado === EstadoDocumentoFormalizacion.FIRMADO
    );
    return anexoFirmado && this.estadoSolicitud == EstadoSolicitud.PREFORMALIZADA;
  }

  /**
   * Obtiene la URL del convenio
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  get urlconvenio(): string {
    let url: string | undefined;
    return url || this.obtenerUrlConvenio();
  }

  /**
   * Obtiene la URL del anexo
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  get urlanexo(): string {
    let url: string | undefined;
    return url || this.obtenerUrlAnexo();
  }

  /**
   * Obtiene la URL del convenio en colección documentos
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  private obtenerUrlConvenio() {
    const urlConvenio = this.documentos?.find(
      doc =>
        doc.tipoDocumento === TipoDocumentosFormalizacion.CONVENIO_EXTRANJERAS &&
        doc.estado === EstadoDocumentoFormalizacion.FIRMADO &&
        doc.url
    );

    return urlConvenio?.url ?? '';
  }

  /**
   * Obtiene la URL del anexo en colección documentos
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  private obtenerUrlAnexo() {
    const urlAnexo = this.documentos?.find(
      doc =>
        doc.tipoDocumento === TipoDocumentosFormalizacion.ANEXO_EXTRANJERAS &&
        doc.estado === EstadoDocumentoFormalizacion.FIRMADO &&
        doc.url
    );

    return urlAnexo?.url ?? '';
  }

  /**
   * Determina si se debe mostrar el botón para visualizar el reconocimiento mediante la URL.
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  get mostrarBotonUrlDocumentoConvenio(): boolean {
    return this.existeUrlConvenio();
  }

  /**
   * Determina si se debe mostrar el botón para visualizar el reconocimiento mediante la URL.
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  get mostrarBotonUrlDocumentoAnexo(): boolean {
    return this.existeUrlAnexo();
  }

  /**
   * Determina si existe la url del convenio en la colección documentos.
   *
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  public existeUrlConvenio(): boolean {
    return (
      !this.documentos ||
      this.documentos?.length === 0 ||
      this.documentos?.some(
        doc =>
          doc.tipoDocumento === TipoDocumentosFormalizacion.CONVENIO_EXTRANJERAS &&
          doc.estado === EstadoDocumentoFormalizacion.FIRMADO &&
          doc.url !== undefined &&
          doc.url !== null &&
          doc.url.trim() !== ''
      )
    );
  }

  /**
   * Determina si existe la url del anexo uno en la colección documentos.
   *
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  public existeUrlAnexo(): boolean {
    return (
      !this.documentos ||
      this.documentos?.length === 0 ||
      this.documentos?.some(
        doc =>
          doc.tipoDocumento === TipoDocumentosFormalizacion.ANEXO_EXTRANJERAS &&
          doc.estado === EstadoDocumentoFormalizacion.FIRMADO &&
          doc.url !== undefined &&
          doc.url !== null &&
          doc.url.trim() !== ''
      )
    );
  }

  /**
   * Determina si se debe mostrar el botón para visualizar el documento.
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  get mostrarBotonUnaFirmaConvenio(): boolean {
    const anexoFirmado = this.documentos?.some(
      documento =>
        documento.tipoDocumento === TipoDocumentosFormalizacion.ANEXO_EXTRANJERAS &&
        documento.estado === EstadoDocumentoFormalizacion.FIRMADO
    );

    const convenioNoFirmado = !this.documentos?.some(
      doc =>
        doc.tipoDocumento === TipoDocumentosFormalizacion.CONVENIO_EXTRANJERAS && doc.estado !== EstadoDocumentoFormalizacion.SIN_FIRMAR
    );

    //Solo muestra el botón si hay anexo firmado y el convenio no está firmado (o no existe)
    return anexoFirmado && convenioNoFirmado;
  }

  /**
   * Determina si el texto debe mostrarse previo al proceso de formalización.
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  get mostrarTextoAsignacion(): boolean {
    return (
      this.estadoSolicitud === EstadoSolicitud.EN_ASIGNACION ||
      this.estadoSolicitud === EstadoSolicitud.ASIGNADA ||
      this.estadoSolicitud === EstadoSolicitud.VALIDADA
    );
  }

  /**
   * Método para generar un documento de una solicitud en formato PDF.
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  public async generarDocumento(bvModalEvent: BvModalEvent) {
    this.show = true;
    this.pdfFirma = true;

    try {
      this.generarFirma(
        bvModalEvent,
        this.generarPdfService().exportarPdfFormalizacion,
        this.solicitudDocumentos.id,
        this.password,
        this.tipoDocumento,
        async solicitudActualizada => {
          try {
            this.documentos.push(solicitudActualizada);
            this.consultarDocumentos();
            await this.preFormalizarSolicitud(this.solicitudDocumentos);
          } catch (error) {
            this.alertService().showHttpError(this, error.response);
          } finally {
            this.pdfFirma = false;
            this.show = false;
          }
        },
        error => {
          this.pdfFirma = false;
          this.show = false;
          this.alertService().showHttpError(this, error.response);
        }
      );
    } catch (error) {
      this.pdfFirma = false;
      this.show = false;
      this.alertService().showHttpError(this, error.response);
    }
  }

  /**
   * Metodo para consultar los documentos de la solicitud
   *
   * @memberof FirmaIndividualFormalizacionComponent
   */
  public consultarDocumentos(): void {
    this.documentoService()
      .findByDocumentosFormalizacionSolicitudId(this.idSolicitud)
      .then(res => {
        this.documentos = res;
      })
      .catch(error => {
        this.alertService().showHttpError(this, error.response);
        throw error;
      });
  }
}
